// extracted by mini-css-extract-plugin
module.exports = {"InputBase":"InputFileBox_InputBase__20GgK","InputFileThumbnail":"InputFileBox_InputFileThumbnail__CmXca","InputErrorText":"InputFileBox_InputErrorText__2i48X"};